import { render, staticRenderFns } from "./DictSelect.vue?vue&type=template&id=c300005e&scoped=true&"
import script from "./DictSelect.vue?vue&type=script&lang=js&"
export * from "./DictSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c300005e",
  null
  
)

export default component.exports